import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { TabItem, Tabs } from '@navi/web-ui/lib/components';
import { useParams } from 'react-router-dom';
import { AnomalyStatus } from '../../types';
import { getAnomalyActionTabs } from '../../utils';
import { useMemo } from 'react';
import OpenAnomalyView from './OpenAnomalyView';
import ClosedAnomalyView from './ClosedAnomalyView';

const AnomalyView = () => {
  const { tabId = '' } = useParams();
  const enableAnomalyTrackerResolution = useSelector(
    (state: RootState) => state?.common?.featureFlags?.enableAnomalyTrackerResolution
  );

  const ANOMALY_TRACKER_ACTION_TABS = useMemo(() => {
    const tabs = getAnomalyActionTabs(enableAnomalyTrackerResolution);
    return tabs;
  }, [enableAnomalyTrackerResolution]);

  // Closed Anomaly View
  if (tabId === AnomalyStatus.CLOSED) {
    return <ClosedAnomalyView />;
  }

  // Open Anomaly View
  return (
    <div className="h-full flex">
      <div className={styles.leftPanel}>
        <OpenAnomalyView />
      </div>
      <div className={styles.rightPanel}>
        <Tabs containerClassName={styles.tabContainerClass} tabsClassName={styles.tabContent}>
          {ANOMALY_TRACKER_ACTION_TABS?.map(tab => {
            return (
              <TabItem key={tab.key} label={tab.value}>
                {/* tabs header height - 53px */}
                <div className="flex flex-col justify-between h-[calc(100%-53px)]">
                  {tab.component}
                </div>
              </TabItem>
            );
          })}
        </Tabs>
      </div>
    </div>
  );
};

export default AnomalyView;
